<!-- 
Pager for pageable tables.

Shows next & previous buttons as well as a text box for typing in a page number.
-->
<template>
  <div class="d-inline-block">
    <our-icon-button
      :disabled="page == 1"
      tooltip="Go to previous page"
      icon="chevron_left" 
      @click="gotoPage(page - 1)"
    />
    <div class="our-table-header-text mx-2">
      Page:
    </div>
    <label :for="uid + '_page'" class="hidden-accessible">Page number</label>
    <input
      :id="uid + '_page'" :name="uid + '_page'" :value="page" type="text"
      class="our-table-header-page-input mr-2" maxlength="5" @keydown.enter="gotoPage($event.target.value)"
    >
    <div class="our-table-header-text mr-2">
      of {{ formattedPages }}
    </div>
    <our-icon-button
      :disabled="page == pages"
      tooltip="Go to next page"
      icon="chevron_right" 
      @click="gotoPage(page + 1)"
    />
  </div>
</template>

<script>
import * as formatting from "@/helpers/formatting.helper";

export default {
  props: {
    paging: {
      type: Object,
      default: null
    }
  },
  computed: {
    uid() {
      return this._uid;
    },
    page() {
      return this.paging ? this.paging.page : 1;
    },
    pages() {
      return this.paging ? this.paging.pages : 1;
    },
    formattedPages() {
      if (this.paging) {
        return formatting.formatNumber(this.pages);
      }
      return null;
    }
  },
  methods: {
    gotoPage: function(page) {
      var value = parseInt(page);
      if (value && value > 0 && value <= this.pages) {
        this.$emit("update:pageNumber", value);
      }
    }
  }
};
</script>

<style lang="scss">
.our-table-header-page-input {
  position: relative;
  top: 1px;
  padding: 3px 5px;
  background-color: #f8f8f8;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  width: 50px;
  font-size: 13px;
  height: 27px;
}
.our-table-header-page-input:focus {
  background-color: white;
}
</style>